var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0.902344H16C18.2091 0.902344 20 2.6932 20 4.90234V16.9023C20 19.1115 18.2091 20.9023 16 20.9023H4C1.79086 20.9023 0 19.1115 0 16.9023V4.90234C0 2.6932 1.79086 0.902344 4 0.902344ZM17.7041 18.6065C18.1561 18.1545 18.41 17.5415 18.41 16.9023V4.90234C18.41 4.26317 18.1561 3.65018 17.7041 3.19822C17.2522 2.74625 16.6392 2.49234 16 2.49234H4C2.66899 2.49234 1.59 3.57134 1.59 4.90234V16.9023C1.59 17.5415 1.84391 18.1545 2.29587 18.6065C2.74784 19.0584 3.36083 19.3123 4 19.3123H16C16.6392 19.3123 17.2522 19.0584 17.7041 18.6065Z",
    fill: "#0065FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.1523H10.75V6.90234C10.75 6.48813 10.4142 6.15234 10 6.15234C9.58579 6.15234 9.25 6.48813 9.25 6.90234V10.1523H6C5.58579 10.1523 5.25 10.4881 5.25 10.9023C5.25 11.3166 5.58579 11.6523 6 11.6523H9.25V14.9023C9.25 15.3166 9.58579 15.6523 10 15.6523C10.4142 15.6523 10.75 15.3166 10.75 14.9023V11.6523H14C14.4142 11.6523 14.75 11.3166 14.75 10.9023C14.75 10.4881 14.4142 10.1523 14 10.1523Z",
    fill: "#0065FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.aa5218c801ed81ef78ced95c88ca1f2a.svg";
export { ForwardRef as ReactComponent };